import { useIntl } from '@context/Internationalization/useIntl'
import { ErrorCodes } from '@enums'
import Error from './Error'

interface IProps {
  errorCode: string
}

const PaymentError: React.FC<IProps> = ({ errorCode }) => {
  const { intl } = useIntl()

  // Check if the error code exists in locale file by attempting to format it
  // If it doesn't exist, intl.formatMessage returns the error code itself
  const errorMessage = intl.formatMessage({ id: errorCode })
  const hasSpecificMessage = errorMessage !== errorCode

  // If no specific message exists, use the generic payment error as fallback
  const fallbackMessage = intl.formatMessage({
    id: ErrorCodes.SUBMISSION_APPROVE_PAYMENT_ERROR,
  })

  return (
    <Error
      showResponseErrorMessage={!hasSpecificMessage}
      errorMessage={fallbackMessage}
      errorCode={errorCode}
    />
  )
}

export default PaymentError
